import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken } from "@/utils/auth";
import { isRelogin } from "@/utils/request";

NProgress.configure({ showSpinner: false });

const whiteList = [
  "/login",
  "/register",
  "/resetPassword",
  "/example/caseList",
];

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (getToken()) {
    to.meta.title && store.dispatch("settings/setTitle", to.meta.title);
    /* has token*/

    if (to.path === "/login") {
      if (from.fullPath == "/dashboard") {
        next({ path: "/" });
        NProgress.done();

        // next({ path: '/' })
        // NProgress.done()
        // this.$router.go(0);
        // window.location.reload();
        // next({ path: '/dashboard' })
      } else {
        next({ path: "/" });
        NProgress.done();
      }
    }
    // else if (from.path === "/example/bug") {
    //   if (store.state.bug.isShowList) {
    //     next();
    //     NProgress.done();
    //   } else {
    //     store.commit("bug/setIsShowList", true);
    //     next({ path: "/example/bug" });
    //     NProgress.done();
    //   }
    // }
    else if (whiteList.indexOf(to.path) != -1) {
      next();
      NProgress.done();
    } else {
      if (store.getters.roles.length === 0) {
        isRelogin.show = true;
        // 判断当前用户是否已拉取完user_info信息
        store
          .dispatch("GetInfo")
          .then(() => {
            isRelogin.show = false;
            store.dispatch("GenerateRoutes").then((accessRoutes) => {
              // 根据roles权限生成可访问的路由表
              // console.log(accessRoutes)
              console.log(accessRoutes);
              router.addRoutes(accessRoutes); // 动态添加可访问路由表
              function findPath(menu, path) {
                console.log(menu, path);
                return menu.some((item) => {
                  // if (item.path.replace(/\//g, '') === path.replace(/\//g, '')) {
                  //   return true;
                  // }
                  if (path.includes(item.path)) {
                    return true;
                  }
                  if (item.children) {
                    return findPath(item.children, path);
                  }
                  return false;
                });
              }

              // console.log(to.path)
              // console.log(accessRoutes)
              // debugger
              const pathExists = findPath(accessRoutes, to.path);

              console.log(pathExists); // 如果存在则输出 true，否则输出 false
              console.log(to.path);
              if (pathExists) {
                next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
              } else {
                if (to.path == "/dashboard") {
                  console.log(accessRoutes);

                  next({
                    path: store.state.permission.routes[0].path,
                  });
                } else {
                  next({ path: "error/404" });
                }
              }
            });
          })
          .catch((err) => {
            store.dispatch("LogOut").then(() => {
              Message.error(err);
              next({ path: "/login" });
            });
          });
      } else {
        function findPath(menu, path, visited = new Set()) {
          console.log(menu, path);
          return menu.some((item) => {
            if (path.includes(item.path)) {
              return true;
            }
            if (item.children && item.children.length) {
              if (visited.has(item.path)) {
                return false; // 避免死循环
              }
              visited.add(item.path);
              return findPath(item.children, path, visited);
            }
            return false;
          });
        }
        if (
          to.path == "/error/404" ||
          to.path == "/login" ||
          to.path == "/register"
        ) {
          next();
        }
        const pathExists = findPath(store.state.permission.routes, to.path);
        if (pathExists) {
          next(); // hack方法 确保addRoutes已完成
        } else {
          if (to.path == "/dashboard") {
            next({ path: "/profile/index" });
          } else {
            next({ path: "/error/404" });
          }
        }
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
